import { createContext } from "react"
import { VideoType } from "../api/video"

export interface QueueContextType {
  add: (video: VideoType) => void
}

export const QueueContext = createContext<QueueContextType | undefined>(
  undefined
)
